import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Users, ArrowRight } from "lucide-react";
import { sfx } from "@/lib/sounds";

export default function ServerCard({ server, index = 0 }) {
  const isOnline = server.status === "online";
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5, delay: index * 0.08 }}
      data-testid={`server-card-${server.key}`}
      className="group relative overflow-hidden rounded-3xl bg-[#141414] border-[3px] border-white/10 hover:border-[#FFBF00]/60 hover-blocky blocky-shadow"
    >
      <Link to={`/servers/${server.key}`} onClick={() => sfx.click()} className="block">
        <div className="relative aspect-[16/10] overflow-hidden">
          <img
            src={server.image}
            alt={server.name}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/10" />
          <div className="absolute top-3 left-3 flex items-center gap-2 px-2.5 py-1 rounded-full glass text-xs font-mono">
            <span className={`w-2 h-2 rounded-full ${isOnline ? "bg-green-500 pulse-dot" : "bg-red-500"}`} />
            {isOnline ? "ONLINE" : "OFFLINE"}
          </div>
          <div className="absolute top-3 right-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full glass text-xs">
            <Users size={12} className="text-[#FFBF00]" />
            <span className="font-mono">{server.players_online}/{server.max_players}</span>
          </div>
        </div>
        <div className="p-6 bg-gradient-to-b from-transparent to-[#FFBF00]/5">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#FFBF00] font-bold">{server.tagline}</div>
          <div className="font-hero text-2xl sm:text-3xl mt-1 text-white">{server.name}</div>
          <p className="mt-2 text-sm text-white/60 leading-relaxed">{server.description}</p>
          <div className="mt-4 flex flex-wrap gap-1.5">
            {(server.highlights || []).slice(0, 4).map((h) => (
              <span key={h} className="text-[10px] uppercase tracking-wider px-2.5 py-1 rounded-full border-2 border-white/10 text-white/70 font-semibold">
                {h}
              </span>
            ))}
          </div>
          <div
            data-testid={`server-join-${server.key}`}
            className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-black text-sm font-bold uppercase tracking-wider blocky-shadow-black border-2 border-black transition-transform group-hover:translate-x-1"
            style={{ backgroundColor: server.color || "#FFBF00" }}
          >
            Explore Server <ArrowRight size={14} />
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
